/**
 * Maps a webstore cart line to its Tealium `inventory_class` — "the source the
 * product belongs to" (PSSD-3724). Schema values: inventory | showcase | pga |
 * oem_parts. Showcase WG units add via the ARI CMS inventory PDP (external), so
 * they are not produced by the webstore emitters.
 *
 * @param {number|string} catalogId Cart item catalog id (OEM = 2).
 * @param {Object} [product] get_variation response (has is_wg). When the
 *   variation fetch failed the caller passes {} (or nothing); we cannot know
 *   is_wg, so return '' rather than guessing and mislabeling a whole-goods line.
 * @returns {'inventory'|'oem_parts'|'pga'|''}
 */
export default function inventoryClass(catalogId, product) {
    if (!product || Object.keys(product).length === 0) {
        return '';
    }
    if (product.is_wg) {
        return 'inventory';
    }
    if (Number(catalogId) === 2) {
        return 'oem_parts';
    }
    return 'pga';
}
